const SERVER_TIMEZONE_OFFSET_MINUTES = 8 * 60;

function pad(value) {
  return String(value).length < 2 ? '0' + value : String(value);
}

function parseServerTime(value) {
  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === 'number' || (typeof value === 'string' && /^\d{10,13}$/.test(value.trim()))) {
    var timestamp = Number(value);
    if (!isFinite(timestamp) || timestamp <= 0) return null;
    if (timestamp < 100000000000) timestamp *= 1000;
    var timestampDate = new Date(timestamp);
    return isNaN(timestampDate.getTime()) ? null : timestampDate;
  }

  if (typeof value !== 'string') return null;
  var text = value.trim();
  if (!text || text === '0000-00-00 00:00:00' || text === '0000-00-00') return null;

  var match = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/.exec(text);
  if (match) {
    var utcTime = Date.UTC(
      Number(match[1]),
      Number(match[2]) - 1,
      Number(match[3]),
      Number(match[4] || 0),
      Number(match[5] || 0),
      Number(match[6] || 0)
    ) - SERVER_TIMEZONE_OFFSET_MINUTES * 60 * 1000;
    var serverDate = new Date(utcTime);
    return isNaN(serverDate.getTime()) ? null : serverDate;
  }

  var parsed = new Date(text);
  return isNaN(parsed.getTime()) ? null : parsed;
}

export function formatBrowserTime(value, format) {
  var date = parseServerTime(value);
  if (!date) return '--';

  var monthDay = pad(date.getMonth() + 1) + '-' + pad(date.getDate());
  var clock = pad(date.getHours()) + ':' + pad(date.getMinutes());
  if (format === 'short') return monthDay + ' ' + clock;

  return date.getFullYear() + '-' + monthDay + ' ' + clock + ':' + pad(date.getSeconds());
}

export { parseServerTime };
